<div class="popup-common standard-popup">
  <img class="background-img" [src]="'assets/images/early-charge/' + langCode + '.png'" alt="" lazy="loading" />

  <img
    class="btn-img onact96-not"
    [src]="'assets/images/early-charge/btn/' + langCode + '.png'"
    alt=""
    lazy="loading"
    (click)="goToFaitDeposit()"
  />
</div>
